export default __webpack_public_path__ + "static/media/img-hero-desktop-03-beatz.789b4868.jpg";